import { Modal, ModalProps } from 'antd/lib';
import React, { ReactNode } from 'react';
import { IconNames } from 'components/UI/Icon/icons';
import { Icon } from 'components/UI/Icon/Icon';
import styles from './Generic.module.css';
import clsx from 'clsx';

interface GenericModalProps extends ModalProps {
	children: ReactNode;
	'data-testid'?: string;
}
const GenericModal: React.FC<GenericModalProps> = ({
	'data-testid': dataTestId,
	title,
	children,
	className,
	...restProps
}: GenericModalProps) => {
	const genericModalStyles = clsx(className, {
		[styles['ant-modal-body']]: true,
	});

	return (
		<Modal
			{...restProps}
			{...(dataTestId && {
				modalRender: (modal: React.ReactNode) => (
					<div data-testid={dataTestId}>{modal}</div>
				),
			})}
			title={null}
			closeIcon={<Icon component={IconNames.CROSS} size={24} />}
			className={genericModalStyles}
		>
			<h2 className="bold">{title}</h2>
			{children}
		</Modal>
	);
};

export { GenericModal };
